module.exports = __webpack_public_path__ + "img/_empty_states_chat.7221aa8a.svg";